import * as React from "react";
import { forwardRef } from "react";
const SvgSubtract = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M19 13H14H13H11H10H5V11H10H11H13H14H19V13Z", fill: "#4555D6" }));
const ForwardRef = forwardRef(SvgSubtract);
export { ForwardRef as ReactComponent };
